import { render, staticRenderFns } from "./registerForm.vue?vue&type=template&id=dea6b850&"
import script from "./registerForm.vue?vue&type=script&lang=ts&"
export * from "./registerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports